<mat-form-field subscriptSizing="fixed">
  <mat-label>{{ label | translate }}</mat-label>
  <input data-cy="phone-number-input" #phone matInput type="text" [formControl]="control" role="input" />
  <mat-hint *ngIf="showHint" class="hint-message body-3">
    {{ hintMessage | translate }}
  </mat-hint>
  <mat-error *ngIf="control.invalid">{{ errorMessage | translate }}</mat-error>
</mat-form-field>
